<!-- s -->
<template>
  <div>
    <el-dialog
      title="查看日志"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="close"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <commonTable
        v-if="tableLabel.length > 0"
        :loading="loading"
        :tableData="tableData"
        :tableLabel="tableLabel"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pageInfo.pageSize"
        :currentPage="pageInfo.page"
        :total="pageInfo.total"
      ></commonTable>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 退款单操作日志查看弹窗
 * 功能：分页展示退款单的操作日期/操作人/内容。
 * 备注：created() 生命周期重复定义两次（后一个生效）；lookCity 方法已定义但未在模板中使用（死代码）。
 */
import { getRefundLog } from "@/api/user";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  /** 弹窗打开时加载日志列表（与下方 data 后的 created 重复定义） */
  created() {
    this.getList();
  },
  data() {
    return {
      // 表格加载状态
      loading: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 日志列表数据
      tableData: [],
      // 表格行 key
      rowKey: "id",
      // 分页参数
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableLabel: [
        {
          label: "序号",
          param: "xId",
          align: "center",
          width: "50px",
          show: true,
        },
        {
          label: "操作日期",
          param: "operationTime",
          align: "center",
          width: "165px",
          show: true,
        },
        {
          label: "操作人",
          param: "operator",
          align: "center",
          width: "120px",
          show: true,
        },
        { label: "内容", param: "description", align: "center", show: true },
      ],
    };
  },
  /** 弹窗打开时加载日志列表（与 props 前的 created 重复定义，后一个生效） */
  created() {
    this.getList();
  },
  methods: {
    /** 打开弹窗并重新加载日志（疑似死代码：模板中未使用） */
    lookCity(row) {
      this.dialogFormVisible = true;
      this.getList();
    },
    /** 每页条数变化时重新查询
     * @param {Number} value 每页条数
     */
    handleSizeChange(value) {
      this.pageInfo.pageSize = value;
      this.pageInfo.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询
     * @param {Number} value 当前页码
     */
    handleCurrentChange(value) {
      this.pageInfo.page = value;
      this.getList();
    },
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /** 分页查询退款单操作日志 */
    getList() {
      //   this.pageInfo.refundId = this.scope.refundId;
      let obj = {
        refundId: this.scope.refundId,
        pageInfo: this.pageInfo,
      };
      getRefundLog(obj)
        .then((result) => {
          if (result.code == 200) {
            this.loading = false;
            this.tableData = result.data.records;
            this.pageInfo.total = result.data.total;
            // this.tableLabel = this.getTableLabel();
          }
        })
        .catch((err) => {});
    },
  },
};
</script>